export default "__VITE_ASSET__Dgdzj8OA__"